import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from '../components/ui/sonner';

function formatApiError(error) {
  return error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Unable to change password.';
}

export default function ChangePasswordPage() {
  const { changePassword } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('New password confirmation does not match');
      return;
    }

    setSaving(true);

    try {
      await changePassword(currentPassword, newPassword, confirmPassword);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      toast.success('Password changed successfully');
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-5 animate-fade-in" data-testid="change-password-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#1C1B1A]" style={{ fontFamily: 'Manrope, sans-serif' }}>Change Password</h1>
        <p className="text-[#5C5A56] text-sm mt-1">Update your password securely from the account menu.</p>
      </div>

      <Card className="border-[#E8E6E1] shadow-sm rounded-2xl">
        <CardHeader>
          <CardTitle className="text-[#1C1B1A]">Security</CardTitle>
          <CardDescription>Use your current password, then set a new one with at least 6 characters.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-5 max-w-2xl">
            <div className="space-y-2">
              <Label htmlFor="current-password">Current Password</Label>
              <Input id="current-password" name="current_password" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} className="border-[#E8E6E1]" required />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="space-y-2">
                <Label htmlFor="new-password">New Password</Label>
                <Input id="new-password" name="new_password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="border-[#E8E6E1]" minLength={6} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="confirm-password">Confirm New Password</Label>
                <Input id="confirm-password" name="new_password_confirmation" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="border-[#E8E6E1]" minLength={6} required />
              </div>
            </div>
            <div className="flex justify-end">
              <Button type="submit" className="bg-[#1E3F2D] hover:bg-[#29563E] text-white rounded-xl" disabled={saving}>
                {saving ? 'Updating...' : 'Update Password'}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
